/**
 * @author vishwadeep.kapoor
 * @Date: 2019-05-07 15:52:43
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2020-06-17 17:49:57
 */
import React from 'react';
import { shape } from 'prop-types';
import Helmet from 'react-helmet';
import { constants, metaTags, utils } from '../../devUtils';
import endPoints from '../../config/endPoints';

const HelmetWrapper = (props) => {
  const { location: { pathname = '' } } = props;
  const {
    title,
    description,
    keywords,
    twitterdescription,
    ogtype,
    image,
  } = metaTags[pathname] || metaTags[constants.LINK_HOME];
  const localBusinessScheme = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Zaggle Corporation',
    image: endPoints.ZAGGLE_LOGO.URL,
    '@id': `${utils.getBaseUrl()}${pathname}`,
    url: `${utils.getBaseUrl()}${pathname}`,
    telephone: '022 4879 4879',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Boomerang Building, Ground Floor, B-1004, Yadav Nagar, Chandivali. Powai, Mumbai- 400072',
      addressLocality: 'Mumbai',
      postalCode: '400072',
      addressCountry: 'IN',
    },
    sameAs: [
      'https://www.facebook.com/zaggleapp/',
      'https://twitter.com/zaggleapp',
      'https://www.instagram.com/zaggleapp/',
      'https://www.youtube.com/channel/UCF44bUtUAgnMNOTzyvXvkgQ?view_as=subscriber',
      'https://www.linkedin.com/company/zaggleapp/',
    ],
  };
  return (
    <Helmet>
      <title>{title || 'Zaggle| Global Digital Bank in India |  Financial Technology Company'}</title>
      <meta name="description" content={description || 'The world’s best Digital Bank is now in India. Get ready to experience effortless banking in a safe and secure way. Visit us at www.zaggle.in for further information.'} />
      <meta name="keywords" content={keywords || 'Global Digital Bank, Financial Technology Company'} />
      <link rel="canonical" href={`${utils.getBaseUrl()}${pathname}`} />
      <meta name="image" content={image || endPoints.ZAGGLE_JOURNEY.URL} />
      <meta property="og:title" content={title || 'Zaggle| Global Digital Bank in India |  Financial Technology Company'} />
      <meta property="og:site_name" content="zaggle" />
      <meta property="og:url" content={`${utils.getBaseUrl()}${pathname}` || constants.LINK_HOME} />
      <meta property="og:description" content={description || 'The world’s best Digital Bank is now in India. Get ready to experience effortless banking in a safe and secure way. Visit us at www.zaggle.in for further information.'} />
      <meta property="og:type" content={ogtype || 'business'} />
      <meta property="og:image" content={image || endPoints.ZAGGLE_JOURNEY.URL} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@zaggleapp" />
      <meta property="twitter:url" content={`${utils.getBaseUrl()}${pathname}` || constants.LINK_HOME} />
      <meta name="twitter:title" content={title || 'Zaggle - Gift Card System'} />
      <meta name="twitter:description" content={twitterdescription || 'The world’s best Digital Bank is now in India. Get ready to experience effortless banking in a safe and secure way. Visit us at www.zaggle.in for further information.'} />
      <meta name="twitter:image" content={image || endPoints.ZAGGLE_JOURNEY.URL} />
      <meta name="robots" content="index, follow" />
      <link rel="alternate" href={`${utils.getBaseUrl()}${pathname}`} hrefLang="en-in" />
      <link rel="alternate" href={`${utils.getBaseUrl()}${pathname}`} hrefLang="en-us" />
      <script type="application/ld+json">
        {JSON.stringify(localBusinessScheme)}
      </script>
    </Helmet >
  );
};
HelmetWrapper.propTypes = {
  location: shape({}),
};
HelmetWrapper.defaultProps = {
  location: {},
};
export default HelmetWrapper;



// WEBPACK FOOTER //
// client/components/HelmetWrapper/index.js